import React from "react";
import PlassertCard from "./Cards/PlassertCard";
import {BarnBarnehageplassStatus} from "../../api/barnehageplassStatus";

interface Props {
    alleBarnBarnehageplassStatus: Array<BarnBarnehageplassStatus> | undefined;
}

export function PlassertCardOversikt({
                                         alleBarnBarnehageplassStatus
                                     }: Props) {

    if (alleBarnBarnehageplassStatus === undefined) {
        return ""
    }

    return (
        <>
            {alleBarnBarnehageplassStatus.map((barn) =>
                <div className={"my-size-24"} key={barn.ident}>
                    <PlassertCard barnNavn={barn.navn} barnehageplasser={barn.barnehageplasser ? barn.barnehageplasser : [] }/>
                </div>
            )}
        </>)
}
